import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "axios";

import { enum_api_uri } from "common/hooks/utils/enum";
import { useAuthStore } from "user/store/useAuthStore";

interface Request {
    member_idx: number;
    token: string;
    new_password: string;
}

interface Response {
    data: null;
}

export const usePutResetPassword = (successCallback?: () => void): UseMutationResult<Response, Error, Request, unknown> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<Response, Error, Request>({
        mutationFn: async ({ member_idx, token, new_password }: Request) => {
            const response = await axios.put(
                enum_api_uri.user.put_reset_password,
                {
                    member_idx,
                    token,
                    new_password,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data;
        },
        onSuccess: data => {
            successCallback?.();
        },
        // onError: (error: Error) => {
        //     console.error("로그인 실패:", error);
        // },
        // isError로 수정해보기
    });
};
